module.exports = __webpack_public_path__ + "img/login-bg-blue2.ab83cc8e.png";